module.exports = __webpack_public_path__ + "static/img/partner-txd.06906a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-txd.png
// module id = fvOh
// module chunks = 34